// The real site hbnuevavalladolid.com does NOT have a dedicated restaurant section
// on the homepage. The homepage section order is:
//   hero → why-choose → rooms → work-and-meetings → image-carousel →
//   testimonials → activities → instagram-cta → final-cta
//
// This component returns null so it renders nothing and the section is omitted
// from the page entirely, matching the real site.

export function RestaurantPreview() {
  return null
}
